// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NTh3","content":"styles_content__2eKlA"};